import React, { Suspense } from 'react';
import { useFormContext } from 'react-hook-form';

import {
  InteractionAccordionPanelProps,
  InteractionModalComponentProps,
} from '$/components/Interactions/types';
import { PurchasePixel } from '$/components/ui/Input/Editors/EmbedCodeBox';

import { useMe } from '$/hooks/useMe';
import { createWebinarSetPurchasePixelUrl } from '$/utils/pixel';

import { PurchaseTrackingPopup } from '../Offer/PurchaseTrackingPopup';
import Form from '$/components/ui/Form';
import Settings from '$/components/ui/Settings';

const ConversionNotificationsSettingsContent = React.lazy(
  () => import('./ConversionNotificationsSettingsContent')
);

const ConversionNotificationsSettings: (
  props: InteractionModalComponentProps
) => InteractionAccordionPanelProps[] = (props) => {
  const { interaction, state, onToggleAccordionRef } = props;
  const me = useMe();
  const { formState } = useFormContext();

  const pixelUrl = createWebinarSetPurchasePixelUrl(me.team, state.set.id);

  React.useEffect(() => {
    if (formState.isSubmitted && !formState.isValid) {
      if (onToggleAccordionRef?.current) {
        onToggleAccordionRef.current([{ key: 'Settings', open: true }]);
      }
    }
  }, [formState.isSubmitted, formState.isValid, onToggleAccordionRef]);

  return [
    {
      key: 'Settings',
      active: !interaction.isNew,
      title: {
        content: (
          <div>
            <Form.AccordionTitle title={'Settings'} />
          </div>
        ),
      },
      content: {
        content: (
          <Suspense>
            <ConversionNotificationsSettingsContent {...props} />
          </Suspense>
        ),
      },
    },
    {
      key: 'SalesTracking',
      title: {
        content: (
          <Form.AccordionTitle
            title={
              <div className='inline-flex'>
                Conversion tracking <PurchaseTrackingPopup />
              </div>
            }
          />
        ),
      },
      content: {
        content: (
          <>
            <div className='flex flex-col flex-grow justify-center items-center'>
              <Settings.Description>
                Put this code in your checkout page. Even if you have more than one Offer card in
                your webinar you only need to copy and paste this code once. For more help see{' '}
                <a
                  href='https://ewebinar.com/help/how-do-i-track-product-sales-from-offers-made-in-ewebinar'
                  target='_blank'
                  rel='noopener'
                >
                  this help article
                </a>
                .
              </Settings.Description>
              <PurchasePixel purchasePixelUrl={pixelUrl} />
            </div>
          </>
        ),
      },
    },
  ];
};

export default ConversionNotificationsSettings;
